import React from 'react';
import { useFormikContext } from 'formik';
import { useSearchQuestion, useSearchResults } from '../../../context/DataContext';
import { useClickAway } from '../../../hooks/useClickAway';

const Suggestions = () => {
  const { setShowSuggestions } = useSearchQuestion();
  const { suggestions, showSuggestions } = useSearchResults();
  const { values } = useFormikContext();
  const { submitForm, setFieldValue } = useFormikContext();

  const ref = useClickAway(() => setShowSuggestions(false));

  const getHighlightedText = (text, highlight) => {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <span>
        {' '}
        {parts.map((part, i) => (
          <span key={i} className={part.toLowerCase() === highlight.toLowerCase() ? 'tt-highlight' : ''}>
            {part}
          </span>
        ))}{' '}
      </span>
    );
  };

  const clickHandler = (obj) => {
    setShowSuggestions(false);
    setFieldValue('query', obj);
    submitForm();
  };

  return (
    <>
      <div
        ref={ref}
        className={showSuggestions && suggestions.length ? 'tt-menu tt-open' : 'tt-menu'}
        style={showSuggestions && suggestions.length ? { display: 'block' } : { display: 'none' }}
      >
        <div className="tt-dataset tt-dataset-organic">
          {!!suggestions.length &&
            suggestions.map((obj, i) => (
              <div key={i} className="tt-suggestion tt-selectable" onClick={() => clickHandler(obj)}>
                {getHighlightedText(obj, values.query)}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Suggestions;
